"use client"

import { ArrowRight } from "lucide-react"

type Props = {
    onNext: () => void
}

export function LandingPage({onNext}:Props) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full bg-blue-50 overflow-x-hidden">
        <h1 className="xl:text-5xl text-3xl font-bold m-3 text-black">Welcome</h1>
        <p className="xl:text-2xl text-base text-blue-500">Select User Type</p>
        <div className="xl:text-2xl text-lg bg-white place-items-center rounded-3xl p-6 mt-4">
            <div className="w-48 h-auto rounded-full bg-blue-500 flex items-center justify-center shadow-lg overflow-hidden">
                <img src={"User_Profile.png"} alt="Profile" className="w-full h-full object-cover"/>
            </div>
            <p className="text-xl uppercase text-black tracking-wide font-medium mt-3">Accounts Payable Manager</p>
        </div>
        <button className="flex items-center bg-blue-500 text-white text-2xl rounded-full py-3 px-10 mt-6" onClick={onNext}
        >
          <span className="mr-3">NEXT</span>
          <ArrowRight />
        </button>
    </div>
  )
}
